var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.6,25H47.47V19.11a15.05,15.05,0,1,0-30.1,0V25H10a2,2,0,0,0-2,2V58a2,2,0,0,0,2,2H52.6A3.51,3.51,0,0,0,56,56.52v-28A3.51,3.51,0,0,0,52.6,25ZM37,42.05A5.2,5.2,0,0,1,35.08,44v6a2.63,2.63,0,0,1-5.25,0V44A5.25,5.25,0,1,1,37,42.05ZM22.62,25V19.61a9.8,9.8,0,1,1,19.6,0V25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.63f73b7d.svg";
export { ForwardRef as ReactComponent };